import axios from 'axios'

export default {
  /**
   * Get all active discounts (public - for dropdowns)
   */
  getAll() {
    return axios.get('/api/discounts')
  },

  /**
   * Get all discounts (admin)
   */
  getAllAdmin() {
    return axios.get('/api/admin/discounts')
  },

  /**
   * Get a single discount
   */
  getById(id) {
    return axios.get(`/api/admin/discounts/${id}/show`)
  },

  /**
   * Create a new discount
   */
  create(data) {
    return axios.post('/api/admin/discounts', data)
  },

  /**
   * Update a discount
   */
  update(id, data) {
    return axios.patch(`/api/admin/discounts/${id}/update`, data)
  },

  /**
   * Delete a discount
   */
  delete(id) {
    return axios.delete(`/api/admin/discounts/${id}/destroy`)
  },

  /**
   * Update sort order for discounts
   */
  updateOrder(ids) {
    return axios.post('/api/admin/discounts/update-order', { ids })
  }
}
